import { render, staticRenderFns } from "./MNotice.vue?vue&type=template&id=7e593d27&"
import script from "./MNotice.vue?vue&type=script&lang=ts&"
export * from "./MNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports